import { useEffect, useState } from "react";
import { t } from "@/game/i18n";
import { Skin, pupSprite } from "@/game/sprites";
import { BREATHER_MS } from "@/game/engine";

export const Breather = ({ skin, onPant }: { skin: Skin; onPant: () => void }) => {
  const [ms, setMs] = useState(0);
  useEffect(() => {
    onPant();
    const start = performance.now();
    const id = setInterval(() => setMs(performance.now() - start), 100);
    return () => clearInterval(id);
  }, [onPant]);
  const countStart = BREATHER_MS - 3500;
  const count = ms < countStart ? null : ms < countStart + 1000 ? 3 : ms < countStart + 2000 ? 2 : ms < countStart + 3000 ? 1 : 0;
  return (
    <div data-testid="breather-overlay" className="fixed inset-0 z-[60] flex flex-col items-center justify-center bg-[#1a0804]/95 animate-fade-in text-center px-6">
      <div className="breather-pup-wrap"><div data-testid="breather-pup" className="breather-pup" style={{ backgroundImage: `url(${pupSprite(skin, "pup_down")})` }} /></div>
      {count === null && (
        <>
          <div data-testid="breather-text" className="eyebrow mt-4">{t("catchBreath")}</div>
          <div className="title-h2 mt-2">{t("getReady")}</div>
        </>
      )}
      {count !== null && count > 0 && <div key={count} data-testid="breather-count" className="breather-count">{count}</div>}
      {count === 0 && <div data-testid="breather-go" className="breather-count breather-go">{t("go")}</div>}
    </div>
  );
};
